var $menuButton = $('.main-nav .nav-menu #nav-icon');
var $header = $('header');
var $body = $('body');
var $contentSection = $('#content-section');
var $footer = $('footer');
var $menuContent = $('.main-nav .nav-menu .menu-content ul');
$menuContent.addClass('display-none');

function hideMenu() {
    $menuButton.removeClass('open');
    $menuButton.attr('aria-expanded', 'false');
    $('.main-nav .nav-menu .menu-content').attr('inert', 'inert').css({
        'max-height': 0,
        'opacity': 0
    });
    if ($(window).width() <= 600) {
        $('.main-nav .nav-menu #header-search').attr('inert', 'inert').css({
            'max-height': 0,
            'opacity': 0
        });
        $('.main-nav .nav-menu #header-search #header-search-input').css({
            'max-height': 0,
            'opacity': 0
        });
    }
    setTimeout(function () {
        $header.removeClass('show-nav');
    }, 400);
    $body.removeClass('no-scroll-y');
    setTimeout(function () {
        $menuContent.addClass('display-none');
        $menuContent.removeClass('anim');
        $('.main-nav .nav-menu .menu-content').removeClass('anim');
        $('.main-nav .nav-menu .menu-content .content-bottom').removeClass('anim');
    }, 500);
}

if ($menuButton) {
    $menuButton.click(function () {
        if ($menuButton.hasClass('open')) {
            hideMenu();
        } else {
            $('.main-nav .nav-menu .menu-content').addClass('anim');
            $('.main-nav .nav-menu .menu-content').removeAttr('inert').css({
                'max-height': '100%',
                'opacity': 1
            });
            if ($(window).width() <= 600) {
                $('.main-nav .nav-menu #header-search').removeAttr('inert').css({
                    'max-height': '50px',
                    'opacity': 1
                });
                $('.main-nav .nav-menu #header-search #header-search-input').css({
                    'max-height': '50px',
                    'opacity': 1
                });
            }
            $('.main-nav .nav-menu .menu-content .content-bottom').addClass('anim');
            setTimeout(function() {
                $menuContent.addClass('anim');
            }, 500 );
            $menuButton.addClass('open');
            $menuButton.attr('aria-expanded', 'true');
            $header.addClass('show-nav');
            $body.addClass('no-scroll-y');
            $menuContent.removeClass('display-none');
        }
    });
}